import { motion } from "framer-motion";

export default function Chapter({ no, kicker, heading, sub, light = false }) {
  return (
    <div className="mb-14 sm:mb-20" data-testid={`chapter-${no}`}>
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8 }}
        className={`flex items-baseline gap-5 border-t pt-5 ${light ? "border-white/15" : "border-ink/15"}`}
      >
        <span className="font-mono text-xs font-semibold tracking-[0.25em] text-srs">{no}</span>
        <span className={`font-mono text-[11px] uppercase tracking-[0.28em] ${light ? "text-white/50" : "text-subtle"}`}>
          {kicker}
        </span>
        <span className={`ml-auto hidden font-mono text-[10px] uppercase tracking-[0.2em] sm:block ${light ? "text-white/30" : "text-ink/25"}`}>
          Sun Roofing Solutions
        </span>
      </motion.div>
      <div className="mt-10 max-w-3xl">
        <motion.h2
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className={`font-display text-4xl font-semibold leading-[1.02] tracking-[-0.02em] sm:text-5xl lg:text-6xl ${
            light ? "text-white" : "text-ink"
          }`}
        >
          {heading}
        </motion.h2>
        {sub && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, delay: 0.12, ease: [0.16, 1, 0.3, 1] }}
            className={`mt-6 text-base leading-relaxed sm:text-lg ${light ? "text-white/60" : "text-mute"}`}
          >
            {sub}
          </motion.p>
        )}
      </div>
    </div>
  );
}
